(() => {
  'use strict';
  const params = new URLSearchParams(window.location.search);
  // Shopify zet een previewcookie en verwijdert preview_theme_id daarna uit de URL (drie HTTP-proeven,
  // 21 sep 2026), dus de adresbalk kan de poort niet dragen. De gerenderde identiteit wel: role is
  // 'unpublished' op een werkkopie, 'development' bij theme dev en 'main' op live. Allowlist.
  const theme = window.Shopify && window.Shopify.theme;
  if (!theme || !['unpublished', 'development'].includes(theme.role)) return;
  const root = document.documentElement;
  const skel = params.get('eyk_skel');
  if (skel === '1' || skel === '2') {
    root.classList.remove('eyk-skel-1', 'eyk-skel-2');
    root.classList.add(`eyk-skel-${skel}`);
  }
})();
